module.exports = __webpack_public_path__ + "img/bracket_1_simple_bg.482d803c.png";